export const TableSeatingIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <rect width="24" height="24" rx="6" fill="url(#pattern0_8315_4775)" />
      <defs>
        <pattern
          id="pattern0_8315_4775"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use xlinkHref="#image0_8315_4775" transform="scale(0.0434783)" />
        </pattern>
        <image
          id="image0_8315_4775"
          width="23"
          height="23"
          preserveAspectRatio="none"
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAXCAIAAABvSEP3AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAxFJREFUeNqEVTtMIlEUncd8wBksZOKnIAqoiYi6MbGBJZCYmFiQbS0laky0UFsSijWxhMLCSMNSaGdhLC0ksbAw0UIlYqdgpAEiiH8Z2LPMZhaGz95QPB733XfOuec+yPi3cYZhyuUyVRfY+vj4KEkSy3Esy1KNcihCRNFAi6Ko43UUoYiGVH8oDVUqlTw/PDMzM5lsJp1JMyyjysFHQ2uAgCGElCqhuuPz83NgYGD95zpN00NDQ16vV5IkJNdBIRoE1STw8+vraz6fxzqdTqME1TyY+q3393dA02q1qVRqbm5ucHDw5OQE2n19fRWLRY7jsFYdobu6uliOVdRFnt1ud7lc9/f3ODA1NdXR0YGc6+vrsbGxycnJp6enXC6nkABkjuVqqqIjVqt1a2sLWoyOjgaDwdXVVdQ6Pz+PRqObm5toxcXFxeLiIi6rVkOtC9CiBBZtbW0A+Pb2JnPEGZkImP5HF2TE4/GVlZXe3t7Dw0OgUEpnMpm1tTWbzXZ6egrIf+zTQl3cf3Z2lkgkHh4e+vr6qlsGaaDI3d2dDLY6ahiBbU9Pz+7u7t7e3vLyMojI+2gZCEIv7Pv9/nIlmlZBL41Go8ViAReHw6Gkwizo1MTEBKg5nU6e51Uurek0oGazWZ1OB1Db29uwHOyPrzDOzs6ObKJIJBKLxRRdGnQaVcBiY2MDWNAd+E1JRYBROByGtO3t7a10AXKgDQQC+/v709PTOKBIjio+n+/g4GB2dhbEW1WRXefxePr7+xcWFpTZwQKqYyBNJtP8/Lxer1eNVU0VsEUjLy8vC4UC/AKnyZaBHNDr+PgY83l0dPTy8qIaYzJiG+GFf5pDV0EQDAYD5gjshoeHcQCHr66u0Ozu7m74CMnVcyTwQoMJwJlkMgmln5+fwdFsNqNHOIYX5/b2FhrVvycNXga6EpAQcxAKhYDI7XYvLS3hAmUmWqlbX05+3JRF08zOzk74SjGFErj5Mfd4E79JJhO/IhHojR1SF5XnUkO+2524qsF/APnbe0kqajlt5X+i4cNKGUTxtwADAC/XflQBNG49AAAAAElFTkSuQmCC"
        />
      </defs>
    </svg>
  );
};
